import axios from 'axios'


const headers = {
    // "userAuthType": "MS"
    'gatewayAppId': 'ly-portal-affairs',
    'gatewayserviceid': 'ly-portal-affairs-svc', 
    'X-Requested-With': 'XMLHttpRequest'
}
import serverName from "./serverName"

const s = serverName
// 创建 axios 实例
export default function Request(api, method, data, loading = true, head) {
    return new Promise((resolve, reject) => {
        const instance = axios.create({
            baseURL: '',
            timeout: 15000, // 请求超时时间     
        })
        instance({
            url: s != '' ? "/" + s + api : api,
            headers: head ? head : headers,
            method: method,
            data: data,
        }).then(res => {
            console.log(res,'res');
            if (res.data.code == 200) {
                resolve(res.data.data)
            } else {
                reject(res.data)
            }
            resolve(res) //回调
        }).catch(err => {
            console.log(err,'err');
            reject(err.response.data) //回调
        })
    })
}